import { includes, indexOf, reverse, slice } from "lodash";

export enum Role {
  Supervisor = "supervisor",
  Admin = "admin",
  Writer = "write",
  Reader = "read",
}

const Roles = [Role.Reader, Role.Writer, Role.Admin, Role.Supervisor];

export function getDefaultRole() {
  return Role.Reader;
}

export function getRoles() {
  return Roles;
}

export function hasRightsOver(role1: Role, role2: Role) {
  return Roles.indexOf(role1) >= Roles.indexOf(role2);
}

export function isAdmin(role: Role) {
  return role === Role.Admin;
}

export function isSuperAdmin(role: Role) {
  return role === Role.Supervisor;
}

export function canManageProject(role: Role) {
  return isAdmin(role) || isSuperAdmin(role);
}

export function canWriteOnProject(role: Role) {
  return includes([Role.Writer, Role.Admin, Role.Supervisor], role);
}

export function getRolesFromRole(role: Role) {
  return reverse(slice(Roles, 0, indexOf(Roles, role) + 1));
}
